import IntentProjectEnvironmentMountedFilesTableNameCell from "./NameCell";
import IntentProjectEnvironmentMountedFilesTableDescriptionCell from "./DescriptionCell";
import IntentProjectEnvironmentMountedFilesTableSecretCell from "./SecretCell";
import IntentProjectEnvironmentMountedFilesTableCreatedAtCell from "./CreatedAtCell";
import IntentProjectEnvironmentMountedFilesTableRowActionsCell from "./RowActionsCell";
import { INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID } from "../constants";
import { IntentProjectEnvironmentMountedFilesCellPerColumn } from "../types";

export const INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_TABLE_CELLS: IntentProjectEnvironmentMountedFilesCellPerColumn =
  {
    [INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID.NAME]:
      IntentProjectEnvironmentMountedFilesTableNameCell,
    [INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID.DESCRIPTION]:
      IntentProjectEnvironmentMountedFilesTableDescriptionCell,
    [INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID.SECRET]:
      IntentProjectEnvironmentMountedFilesTableSecretCell,
    [INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID.CREATED_AT]:
      IntentProjectEnvironmentMountedFilesTableCreatedAtCell,
    [INTENT_PROJECT_ENVIRONMENT_MOUNTED_FILES_COLUMN_ID.DROPDOWN]:
      IntentProjectEnvironmentMountedFilesTableRowActionsCell,
  };
